import React from 'react';
import { cn } from '@/lib/utils';
import { useReveal } from '@/lib/motion';

// Обёртка для scroll-reveal: ставит data-reveal и подвешивает узел к общему IO.
// По умолчанию рендерит <div>; через `as` можно поменять тег, чтобы не плодить
// лишнюю обёртку в разметке.
export function Reveal({
  as: Tag = 'div',
  variant = 'up',
  delay,
  className,
  style,
  children,
  ...rest
}) {
  const ref = useReveal({ variant, delay });
  const mergedStyle = { ...(style || {}) };
  if (typeof delay === 'number' && delay > 0) {
    mergedStyle['--reveal-delay'] = `${delay}ms`;
  }
  return (
    <Tag
      ref={ref}
      data-reveal={variant}
      className={cn('reveal', className)}
      style={mergedStyle}
      {...rest}
    >
      {children}
    </Tag>
  );
}

// Контейнер с авто-stagger: каждый прямой потомок получает свой --reveal-delay.
export function RevealStagger({
  as: Tag = 'div',
  variant = 'up',
  step = 70,
  className,
  style,
  children,
  ...rest
}) {
  return (
    <Tag
      data-reveal-stagger={variant}
      style={{ '--reveal-step': `${step}ms`, ...(style || {}) }}
      className={cn(className)}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
